/** @jsxImportSource @emotion/react */
import { Theme, useTheme, Accordion as AccordionMaterial } from '@mui/material';
import React, { ReactNode } from 'react';
import { StylesClassName, UseStyles } from 'types/styles';

interface AccordionProps {
  className?: StylesClassName;
  children: NonNullable<ReactNode>;
}

const Accordion: React.FC<AccordionProps> = ({ className, children }) => {
  const theme = useTheme() as Theme;
  const classes = useStyles(theme);

  return (
    <AccordionMaterial css={[classes.Accordion, className]} TransitionProps={{}}>
      {children}
    </AccordionMaterial>
  );
};

const useStyles = (theme: Theme): UseStyles => ({
  Accordion: {},
});

export default Accordion;
